import { render, staticRenderFns } from "./alipay.vue?vue&type=template&id=7df8a8e8&scoped=true&"
import script from "./alipay.vue?vue&type=script&lang=js&"
export * from "./alipay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df8a8e8",
  null
  
)

export default component.exports